import Button, { ButtonProps } from '@mui/material/Button';
import * as React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

interface Props extends Pick<ButtonProps, 'children' | 'size' | 'color' | 'disabled'> {
    forwardedRef?: React.ForwardedRef<HTMLAnchorElement>;
    pathname: string;
    state?: object;
    className?: string;
}

export default function NavLinkButton({
    forwardedRef = null,
    pathname,
    state,
    className,
    ...buttonProps
}: Props) {
    const NavLink = React.useMemo(
        () =>
            React.forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'>>((props, ref) => (
                <RouterLink
                    ref={ref}
                    to={{
                        pathname: pathname,
                        state: state || {},
                    }}
                    {...props}
                />
            )),
        [pathname, state],
    );

    return (
        <Button {...buttonProps} ref={forwardedRef} component={NavLink} className={className}>
            {buttonProps.children}
        </Button>
    );
}

/**
 * NavLinkIconButtonWithRef
 *
 * @description
 * If parent element component expects to forward ref to this component (ex: is MuiTooltip component):
 * use this component to forward ref from parent to MuiIconButton.
 */
export const NavLinkButtonWithRef = React.forwardRef<
    HTMLAnchorElement,
    Omit<Props, 'forwardedRef'>
>((props, ref) => <NavLinkButton forwardedRef={ref} {...props} />);
